import { render, staticRenderFns } from "./EventDetectionHighCoverage.vue?vue&type=template&id=6fef089e"
import script from "./EventDetectionHighCoverage.vue?vue&type=script&lang=js"
export * from "./EventDetectionHighCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports